import { motion } from 'framer-motion';

export default function Projects() {
  const projects = [
    {
      name: 'Residência Praia do Sino',
      location: 'Ilhabela, SP',
      area: '420m²',
      image: 'https://static.readdy.ai/image/c30d1200a69d27266a785c8d79b381ff/8a0e3469e9e722f188306819536f53b3.png',
      featured: true
    },
    {
      name: 'Casa Ponta das Canas',
      location: 'Ilhabela, SP',
      area: '380m²',
      image: 'https://public.readdy.ai/ai/img_res/1b0240cbeef62032a3c9811178c31ac1.jpg',
      featured: false
    },
    {
      name: 'Residência Curral',
      location: 'Ilhabela, SP',
      area: '350m²',
      image: 'https://static.readdy.ai/image/c30d1200a69d27266a785c8d79b381ff/053f45fb3181721148285acbc46d35ea.jpeg',
      featured: false
    }
  ];

  return (
    <section id="projetos" className="bg-gradient-to-b from-white to-gray-50 py-16 sm:py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-4 sm:px-8 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="mb-12 sm:mb-16"
        >
          <h2 className="font-playfair font-light text-3xl sm:text-4xl lg:text-6xl text-gray-900 mb-3 sm:mb-4">
            Projetos em Ilhabela
          </h2>
          <p className="font-inter text-base sm:text-lg text-gray-600">
            Residências contemporâneas integradas à paisagem litorânea
          </p>
        </motion.div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6 sm:gap-8">
          {projects.map((project, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="group cursor-pointer"
            >
              <div className="bg-white rounded-3xl overflow-hidden shadow-sm hover:shadow-2xl transition-all duration-500">
                <div className="aspect-[4/5] overflow-hidden">
                  <img
                    src={project.image}
                    alt={`${project.name} - Projeto residencial em ${project.location}`}
                    title={`Arquitetura contemporânea ${project.name}`}
                    className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-700"
                  />
                </div>
                <div className="p-6 sm:p-8 text-center">
                  <h3 className="font-inter font-medium text-lg sm:text-xl text-gray-900 mb-2">
                    {project.name}
                  </h3>
                  <div className="flex items-center justify-center gap-2 text-gray-600 mb-3">
                    <i className="ri-map-pin-line text-sm"></i>
                    <span className="font-inter text-sm">{project.location}</span>
                  </div>
                  <p className="font-inter font-bold text-base text-gray-900 mb-4 sm:mb-6">
                    {project.area}
                  </p>
                  <button
                    className={`w-full sm:w-3/4 mx-auto py-3 rounded-full font-inter font-medium text-sm transition-all duration-300 hover:scale-105 whitespace-nowrap ${
                      project.featured
                        ? 'bg-gray-900 text-white hover:bg-gray-800'
                        : 'border-2 border-gray-900 text-gray-900 hover:bg-gray-900 hover:text-white'
                    }`}
                  >
                    Ver Projeto
                  </button>
                  <p className="font-inter text-xs text-gray-400 mt-4">
                    Projeto residencial 2024
                  </p>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mt-12 sm:mt-16"
        >
          <a
            href="#contato"
            className="inline-flex items-center justify-center gap-3 px-6 sm:px-8 py-3 sm:py-4 bg-gray-900 text-white text-sm sm:text-base font-inter font-medium rounded-full hover:bg-gray-800 transition-all duration-300 hover:scale-105 whitespace-nowrap cursor-pointer"
          >
            Ver Portfólio Completo
            <i className="ri-arrow-right-line text-lg"></i>
          </a>
        </motion.div>
      </div>
    </section>
  );
}
